import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useFeatures from "../hooks/useFeatures";

/**
 * PrivateRoute - Proteção de rotas baseada em autenticação e cargo
 * 
 * Props:
 * - children: componente a renderizar se autorizado
 * - adminOnly: boolean - apenas admin tem acesso (default: false)
 * - adminOrSindico: boolean - admin OU síndico têm acesso (default: false)
 * - featureName: string - nome da feature para validar acesso
 */
const PrivateRoute = ({ children, adminOnly = false, adminOrSindico = false, featureName = null }) => {
  const { user, loading } = useAuth();
  const { loading: featuresLoading, hasAccessToFeature } = useFeatures();

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Validar restrições de cargo
  if (adminOnly && user.cargo !== "admin") {
    return <Navigate to="/home" />;
  }

  if (adminOrSindico && user.cargo !== "admin" && user.cargo !== "sindico") {
    return <Navigate to="/home" />;
  }

  if (featureName) {
    if (featuresLoading) {
      return <div>Carregando...</div>;
    }

    // Verificar se usuário tem acesso à feature (não apenas se está ativa)
    if (!hasAccessToFeature(featureName)) {
      return <Navigate to="/home" />;
    }
  }
  return children;
};

export default PrivateRoute;